module.exports = __webpack_public_path__ + "static/media/img_flipCards-06.d140cef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-06.png
// module id = 441
// module chunks = 4